// extracted by mini-css-extract-plugin
export default {"search":"search_search__j3-Dw","icon":"search_icon__tPJdh"};